<template>
  <el-dialog
    :append-to-body="true"
    title="视频设置"
    :visible.sync="show"
    direction="ltr"
    :wrapperClosable="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <div class="drawer-box" 
    v-loading="drawerLoading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading">
      <el-form
        :model="configInfo"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        class="demo-ruleForm form-box"
      >
        <el-form-item label="码流类型:">
          <el-select
            v-model="streamType"
            @change="streamTypeChange"
            placeholder="请选择码流类型"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in streamTypeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频编码类型:">
          <el-select
            v-model="configInfo.video.videoCodecType"
            placeholder="请选择视频编码类型"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in videoCodecTypeList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分辨率:">
          <el-select
            @change="videoResolutionChange"
            v-model="videoResolutionValue"
            placeholder="请选择分辨率"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in videoResolutionList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="码率类型:">
          <el-select
            v-model="configInfo.video.videoQualityControlType"
            placeholder="请选择码率类型"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in videoQualityControlTypeList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="码率:">
          <el-input-number
            v-model="configInfo.video.constantBitRate"
            size="small"
            class="constantBitRate-box"
            controls-position="right"
            :min="constantBitRate.min"
            :max="constantBitRate.max"
            :placeholder="
              '请输入码率(' +
                constantBitRate.min +
                '~' +
                constantBitRate.max +
                ')'
            "
          ></el-input-number>
        </el-form-item>
        <el-form-item label="图像质量:">
          <el-select
          :disabled="configInfo.video.videoQualityControlType == 'CBR' ? true : false"
            v-model="configInfo.video.fixedQuality"
            placeholder="请选择图像质量"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in fixedQualityList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="帧率:">
          <el-select
            v-model="configInfo.video.maxFrameRate"
            placeholder="请选择帧率"
            size="small"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in maxFrameRateList"
              :key="index"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="save-btn-box">
        <el-button type="primary" round size="small" @click="saveClick">提交</el-button>
        <el-button round size="small" @click="handleClose">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showOpen: {
      type: Boolean,
      default() {
        return false;
      }
    },
    cameraInfo: {
      type: Object
    }
  },
  data() {
    //这里存放数据
    return {
      show: false,
      streamType: 1,
      configInfo: {
        deviceSerial: "", //设备序列号
        id: "", //通道+码流。生成规则为：channel*100+streamType（1-mianstream，2-substream）；例如101表示通道1的主码流，302表示通道3的子码流
        channelName: "", //通道名称
        enabled: "", //使能
        video: {
          enabled: true, //使能,音频流和复合流都置为true
          videoInputChannelID: "", //模拟通道ID
          videoCodecType: "", //视频编码类型。取值：”UNKNOWN,MPEG4,MJPEG,3GP,H.264,HK.264,MPNG,SVAC,H.265,H.264BP,H.264HP,H.264SVC”
          videoResolutionWidth: "", //分辨率宽。取值：opt=”352,704,1280,640,1920”
          videoResolutionHeight: "", //分辨率高。 取值：opt=”288,576,720,512,1080”
          videoQualityControlType: "", //码率类型。取值：opt=”CBR,VBR,MVBR,SVBR”，CBR:定码率;VBR:变码率
          constantBitRate: "", //定码率。取值：min=”32” max=”16384”
          fixedQuality: "", //图像质量。取值：opt=”1,20,30,45,60,75,90,100”。1-最低20-较低40-低60-中80-较高100-最高
          maxFrameRate: "", //帧率 如22帧下发2200，1/4帧下发25。取值：opt=”
          keyFrameInterval: "", //I帧间隔,以时间为单位（毫秒）。取值：min=”40” max=”16000”
          smartCodec: {
            enabled: "" //使能
          }
        },
        audio: {
          enabled: "", //复合流时置为true
          audioInputChannelID: "", //模拟通道ID。取值：opt=”1”
          audioCompressionType: "" //视频编码类型。取值：opt=”
        }
      },
      rules: {},
      videoCodecTypeList:[],//视频编码类型数据
      videoResolutionList: [], //分辨率数据
      videoResolutionValue: "", //分辨率
      videoQualityControlTypeList: [], //码率类型数据
      fixedQualityList: [], //图像质量数据
      constantBitRate: {
        //定码率范围
        min: 32,
        max: 16384
      },
      maxFrameRateList: [],
      drawerLoading:false,
      loadingText:'数据加载中...'
    };
  },
  //监控data中的数据变化
  watch: {
    showOpen: function(val) {
      if (val) {
        this.getinfo();
      }
      this.show = val;
    }
  },
  //计算属性，类似于data概念
  computed: {
    streamTypeList() {
      return [
        { id: 1, name: "主码流" },
        { id: 2, name: "子码流" }
      ];
    }
  },
  //方法集合
  methods: {
    handleClose() {
      this.$emit("close");
    },
    streamTypeChange(){
      this.getinfo()
    },
    async getinfo() {
      let req = {
        deviceSerial: this.cameraInfo.deviceSerial,
        channlNo: this.cameraInfo.channlNo,
        streamType: this.streamType
      };
      this.loadingText = '数据加载中...'
      this.drawerLoading = true
      let res = await this.$Http.getCapabilitiesconfig(req);
      this.drawerLoading = false
      if (res.code == 200) {
        let config = res.data.config; // 音视频单通道编码配置
        let capabilities = res.data.capabilities; //音视频单通道编码能力集
        this.configInfo.channelName = config.channelName
        this.videoCodecTypeList = capabilities.video.videoCodecType.opt.split(
          ","
        );
        this.configInfo.deviceSerial = this.cameraInfo.deviceSerial;
        this.configInfo.id = capabilities.id;
        this.configInfo.enabled = config.enabled;
        this.configInfo.video.videoInputChannelID = config.video.videoInputChannelID;
        this.configInfo.video.videoCodecType = config.video.videoCodecType
        this.videoResolutionList = [];
        let widthList = capabilities.video.videoResolutionWidth.opt.split(",");
        let heightList = capabilities.video.videoResolutionHeight.opt.split(
          ","
        );
        this.videoResolutionList = widthList.map((item, index) => {
          let name = item + "*" + heightList[index];
          return name;
        });
        this.configInfo.video.videoResolutionWidth = config.video.videoResolutionWidth
        this.configInfo.video.videoResolutionHeight = config.video.videoResolutionHeight
        this.videoResolutionValue = this.configInfo.video.videoResolutionWidth + '*' + this.configInfo.video.videoResolutionHeight
        this.configInfo.video.videoQualityControlType = config.video.videoQualityControlType
        this.videoQualityControlTypeList = capabilities.video.videoQualityControlType.opt.split(
          ","
        );
        let fixedQualityData = capabilities.video.fixedQuality.opt.split(",")
        this.fixedQualityList = fixedQualityData.map((item,index)=>{
          return Number(item)
        })
        this.configInfo.video.fixedQuality = config.video.fixedQuality
        this.constantBitRate.min = Number(
          capabilities.video.constantBitRate.min
        );
        this.constantBitRate.max = Number(
          capabilities.video.constantBitRate.max
        );
        this.configInfo.video.constantBitRate = config.video.constantBitRate
        let maxFrameRate = capabilities.video.maxFrameRate.opt.split(",");
        maxFrameRate.shift();
        this.maxFrameRateList = maxFrameRate;
        this.configInfo.video.maxFrameRate = config.video.maxFrameRate == 0 ? '' :config.video.maxFrameRate
        this.configInfo.video.keyFrameInterval =
          capabilities.video.keyFrameInterval;
        this.configInfo.video.smartCodec = config.video.smartCodec;
        this.configInfo.audio = config.audio;
      }else if(res.code == -1){
        this.$message({
          type: "warning",
          message: res.messsage || ''
        });
        this.handleClose()
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    videoResolutionChange(val) {
      this.configInfo.video.videoResolutionWidth = Number(val.split("*")[0]);
      this.configInfo.video.videoResolutionHeight = Number(val.split("*")[1]);
    },
    saveClick() {
      this.editInfo()
    },
    async editInfo(){
      let req = Object.assign({},this.configInfo)
      this.loadingText = '数据提交中...'
      this.drawerLoading = true
      let res = await this.$Http.editChannelsConfig(req);
      this.drawerLoading = false
      if (res.code == 200) {
        this.handleClose()
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.drawer-box {
  width: 100%;
  height: 100%;
  .form-box{
    width: 100%;
    height: calc(100% - 100px);
    padding: 0px 10px;
    overflow-y: scroll;
  }
.save-btn-box {
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border:1px solid#D3D3D3;
  button{
    width: 100px;
  }
}
}
.constantBitRate-box {
  width: 100%;
}
.constantBitRate-box /deep/ .el-input__inner{
text-align: left;
}
</style>
